import React from 'react';
import I18n from 'i18n-js';
import { redirectToSignin } from '../signup_signin_helper';
import { RCButton, RCAlertBox } from '@reverbdotcom/cadence/components';
import { Paths } from '../url_helpers';

interface Props {
  email: string;
  orderBundleUuid: string;
}

export default function ClaimOrderBanner(props: Props) {
  const redirectUrl = Paths.orderBundlesClaim.expand({ orderBundleUuid: props.orderBundleUuid });

  return (
    <RCAlertBox type="info">
      <div className="d-flex fx-dir-row fx-justify-between fx-align-center mobile-fx-dir-col mobile-fx-align-start">
        <div className="mobile-mb-2">
          {I18n.t('discovery.checkout.confirmationPage.claimOrderBannerText')}
          <div className="size-fixed-90">
            {props.email}
          </div>
        </div>
        <RCButton
          variant="filled"
          onClick={() => redirectToSignin('ClaimOrderBanner', redirectUrl)}
        >
          {I18n.t('discovery.checkout.confirmationPage.claimOrderButtonText')}
        </RCButton>
      </div>
    </RCAlertBox>
  );
}
